import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {CryptoService} from './crypto.service';
import {environment, isODM} from '../../environments/environment';
export const STORE_KEY_ApiCode = 'ApiCode';


@Injectable({
  providedIn: 'root'
})
export class ApiKeyService {
  apiCode: string;

  constructor(private http: HttpClient, private cryptoService: CryptoService) { }

  ReadApiKeys(param): Observable <any> {
    param = {...param, otp: param.otp + this.cryptoService.hashHmacSha512ForContent(param)};
    return this.http.post<any>(`${environment.apiIotUrl}/api/key/read`, param);
  }

  AddApiKey(param): Observable<any> {
    param = {...param, otp: param.otp + this.cryptoService.hashHmacSha512ForContent(param)};
    return this.http.post<any>(`${environment.apiIotUrl}/api/key/add`, param);
  }

  UpdateApiKey(param): Observable<any> {
    param = {...param, otp: param.otp + this.cryptoService.hashHmacSha512ForContent(param)};
    return this.http.post<any>(`${environment.apiIotUrl}/api/key/update`, param);
  }

  DeleteApiKey(param): Observable<any> {
    param = {...param, otp: param.otp + this.cryptoService.hashHmacSha512ForContent(param)};
    return this.http.post<any>(`${environment.apiIotUrl}/api/key/delete`, param);
  }

  ReadApiKeyUsage(param): Observable<any> {
    param = {...param, otp: param.otp + this.cryptoService.hashHmacSha512ForContent(param)};
    return this.http.post<any>(`${environment.apiIotUrl}/api/key/usage/read`, param);
  }

  set SetApiCode(value) {
    localStorage.setItem(STORE_KEY_ApiCode, value);
    this.apiCode = value;
  }

  get GetApiCode() {
    const data = localStorage.getItem(STORE_KEY_ApiCode);
    return data || '';
  }
}
